export const notificationBannerMock = [
  {
    id: 14,
    creationDate: '2025-01-21T11:09:51.566Z',
    author: 'auth0|6b5744752a404aee8b4ca9f1010b519c',
    type: 'critical',
    startDate: '2025-01-21T12:05:00.000Z',
    endDate: null,
    headline: 'technical issues',
    text: 'We are currently experiencing technical issues. We are working on a solution and we apologize for any inconvenience this may cause you. ',
    linkTitle: '',
    linkUrl: '',
    canDismiss: false,
    isActive: true,
    pages: [
      '/financials/documents/:pool',
      '/financials/earnings/:pool/compare-vessels',
      '/financials/earnings/:pool/pool-vessels',
      '/financials/earnings/:pool/vessel/:vesselCode/earnings',
      '/financials/earnings/:pool/vessel/:vesselCode/payout',
      '/financials/earnings/:pool/vessel/:vesselCode/pool-points',
      '/financials/earnings/:pool/vessel/:vesselCode/bunker-adjustment/*',
      '/financials/earnings/:pool/vessel/:vesselCode/scrubber-bonus',
      '/financials/earnings/:pool/vessel/:vesselCode/voyage',
      '/financials/forecast/:pool',
      '/financials/emission-universe/:pool',
      '/financials/reports/:pool',
      '/calendar/:pool',
      '/news/:pool',
      '/faq',
      '/contact',
      'financials/technical-management',
      'financials/technical-management/:vessel/*',
      '/dashboard/:pool',
    ],
    pools: ['Handy', 'MR', 'LR1', 'LR2', 'Chemicals 2'],
  },
]
